// `before_send` do PostHog no navegador: anexa o contexto do servidor (release, ambiente,
// conta, rota) a todo evento, tira dele query string e e-mail de hóspede, descarta exceção
// que não aponta para código nosso e dá agrupamento estável ao que não tem frame utilizável.
//
// Chega pelo page_context.js, antes do init (posthog_init.js) no mesmo arquivo: existe antes do
// primeiro evento, inclusive os enfileirados antes do init. Por isso é ES5 puro e não depende de
// nada.
(function (window) {
  // Erro de script de outra origem sem CORS: o navegador esconde mensagem e stack. Com os
  // nossos bundles carregados com crossorigin, o que sobra é extensão ou terceiro.
  var OPAQUE = /^Script error\.?$/;
  var NOISE = [
    /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)/,
  ];
  // Chunk do Vite que não carregou: a mensagem traz a URL com o hash do build, e cada chunk de
  // cada release virava uma issue. Mensagens do Chrome/Edge, do Firefox e do Safari.
  var DYNAMIC_IMPORT = /^(Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed)/;
  // Requisição cancelada (navegação, unmount, AbortController) não é defeito.
  var CANCELLED_TYPES = ["AbortError", "CanceledError"];
  var CANCELLED_AXIOS = /^(canceled|Request aborted)$/;
  var LOCATED = /^(https?:|webpack:|[a-z-]+-extension:)/;
  // Requisição que falhou, pendurada pelo interceptor do axios como `cause` do AxiosError
  // (app/javascript/libs/request-failure.ts). A stack do axios é igual para todo endpoint: sem
  // isto, 401, 422 e 502 de chamadas diferentes caem na mesma issue.
  var REQUEST_FAILURE_TYPE = "HttpRequestFailure";
  var REQUEST_FAILURE_VALUE = /^([A-Z]+) (\S+) \u2192 (?:HTTP (\d{3})( session expired)?|(network error)|(timeout))$/;
  // A busca da navbar e os filtros põem nome, e-mail e documento do hóspede na query string, e o
  // posthog-js copia a URL da página para várias propriedades ($current_url, $referrer,
  // $initial_*, $session_entry_*, links do autocapture, web vitals, heatmap). Nenhuma query nem
  // fragmento sai daqui, de URL absoluta ou de caminho dentro de texto.
  var URL_KEY = /(url|referrer|href|pathname)$/i;
  var QUERY = /((?:\bhttps?:)?\/[^\s?#"'<>]*)[?#][^\s"'<>]*/gi;
  // Só em texto de exceção: em $set o e-mail é o do operador, que identifica a pessoa.
  var EMAIL = /[a-z0-9._%+-]+(?:@|%40)[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,}/gi;
  var EXCEPTION_TEXT = ["$exception_list", "$exception_message", "$exception_values"];

  function urlWithoutQuery(url) {
    return String(url).split(/[?#]/)[0];
  }

  function locatedFrames(exceptions) {
    var located = [];
    for (var i = 0; i < exceptions.length; i++) {
      var frames = (exceptions[i] && exceptions[i].stacktrace && exceptions[i].stacktrace.frames) || [];
      for (var j = 0; j < frames.length; j++) {
        if (LOCATED.test(frames[j].filename || "")) located.push(frames[j].filename);
      }
    }
    return located;
  }

  function ours(filename, hosts) {
    if (filename.indexOf("webpack:") === 0) return true;
    return hosts.indexOf(filename.split("/")[2]) !== -1;
  }

  // Altera no lugar. Sem limite de profundidade: um ciclo estoura e o evento é descartado.
  function scrub(value, redactEmail) {
    if (typeof value === "string") {
      value = value.replace(QUERY, "$1");
      return redactEmail ? value.replace(EMAIL, ":email") : value;
    }
    if (!value || typeof value !== "object") return value;
    for (var key in value) {
      if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
      var item = value[key];
      value[key] =
        typeof item === "string" && URL_KEY.test(key)
          ? urlWithoutQuery(item).replace(EMAIL, ":email")
          : scrub(item, redactEmail);
    }
    return value;
  }

  // O heatmap agrupa os cliques pela URL da página, na chave.
  function scrubHeatmap(data) {
    var byPage = {};
    for (var url in data) {
      if (!Object.prototype.hasOwnProperty.call(data, url)) continue;
      var page = urlWithoutQuery(url).replace(EMAIL, ":email");
      byPage[page] = (byPage[page] || []).concat(data[url]);
    }
    return byPage;
  }

  function sanitize(event) {
    var properties = event.properties;
    for (var i = 0; i < EXCEPTION_TEXT.length; i++) {
      if (EXCEPTION_TEXT[i] in properties) properties[EXCEPTION_TEXT[i]] = scrub(properties[EXCEPTION_TEXT[i]], true);
    }
    if (properties.$heatmap_data && typeof properties.$heatmap_data === "object") {
      properties.$heatmap_data = scrubHeatmap(properties.$heatmap_data);
    }
    scrub(properties, false);
    if (event.$set) scrub(event.$set, false);
    if (event.$set_once) scrub(event.$set_once, false);
  }

  function requestFailure(exceptions) {
    for (var i = 0; i < exceptions.length; i++) {
      if (!exceptions[i] || exceptions[i].type !== REQUEST_FAILURE_TYPE) continue;
      var match = REQUEST_FAILURE_VALUE.exec(String(exceptions[i].value || ""));
      if (!match) return null;
      return {
        method: match[1],
        path: match[2],
        status: match[3] ? Number(match[3]) : null,
        sessionExpired: !!match[4],
        network: !!match[5],
        timeout: !!match[6],
        value: match[0]
      };
    }
    return null;
  }

  // IDs mudam por conta/reserva e partiriam o mesmo defeito em várias issues.
  function normalize(message) {
    return String(message)
      .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ":uuid")
      .replace(/\b[0-9a-f]{16,}\b/gi, ":hex")
      .replace(/\d{4,}/g, ":n");
  }

  window.posthogBeforeSend = function (event, context) {
    if (!event) return event;
    // Pedaço da gravação de sessão: as propriedades já saem mascaradas pelo posthog_replay_privacy.js,
    // e parte delas vem comprimida em texto. Trocar qualquer trecho ali (query string, e-mail)
    // corromperia a gravação. O $set/$set_once, que pode levar a URL de entrada, segue limpo.
    if (event.event === "$snapshot") {
      try {
        if (event.$set) scrub(event.$set, false);
        if (event.$set_once) scrub(event.$set_once, false);
      } catch (_error) {
        return null;
      }
      return event;
    }
    context = context || {};
    var properties = event.properties || (event.properties = {});
    var extra = context.properties || {};
    for (var key in extra) {
      if (extra[key] !== null && extra[key] !== undefined && !(key in properties)) properties[key] = extra[key];
    }
    // Grupo da página, vindo do servidor. Substitui o que o posthog-js guarda entre páginas: com duas
    // abas em contas diferentes, o grupo guardado seria o da última aba carregada.
    if (context.groups) properties.$groups = context.groups;
    // Na dúvida o evento não sai: o snippet devolve o evento original quando esta função lança.
    try {
      sanitize(event);
    } catch (_error) {
      return null;
    }
    if (event.event !== "$exception") return event;

    var exceptions = properties.$exception_list || [];
    var first = exceptions[0];
    if (!first) return event;
    var type = String(first.type || "Error");
    var value = String(first.value || "");
    var located = locatedFrames(exceptions);

    if (located.length === 0 && OPAQUE.test(value)) return null;
    for (var n = 0; n < NOISE.length; n++) {
      if (NOISE[n].test(value)) return null;
    }
    // View transition entre páginas abortada pelo navegador (view_transition_abort.js, que o
    // page_context.js carrega antes deste arquivo). A troca de página segue normal.
    if (window.isViewTransitionAbort(type === "DOMException" ? value : type + ": " + value)) return null;
    if (CANCELLED_TYPES.indexOf(type) !== -1 || (type === "AxiosError" && CANCELLED_AXIOS.test(value))) return null;

    var handling = first.mechanism && first.mechanism.handled === false ? "unhandled" : "handled";
    var request = requestFailure(exceptions);
    if (request) {
      // Sessão encerrada: a tela já oferece "Recarregar" (libs/session-expired.ts) e o 401 fica no
      // log de acesso do servidor. Não há o que corrigir no navegador.
      if (request.sessionExpired) return null;
      properties.http_method = request.method;
      properties.http_path = request.path;
      properties.http_status = request.status;
      properties.http_network_error = request.network;
      properties.http_timeout = request.timeout;
      // Rejeição sem tratamento é catch faltando na tela; a tratada é a falha em si. Defeitos
      // diferentes, issues diferentes.
      if (!properties.$exception_fingerprint) {
        properties.$exception_fingerprint = type + " " + request.value + " (" + handling + ")";
      }
      if (!properties.$issue_name) properties.$issue_name = type + ": " + request.value;
      return event;
    }

    // Sem a lista de hosts da CDN (asset_host que o servidor não conseguiu reduzir a um host),
    // um frame http de outro host pode ser bundle nosso: na dúvida o evento fica, porque
    // descartar aqui esconderia todo erro da CDN atrás de um painel vazio.
    var hostsKnown = Object.prototype.toString.call(context.assetHosts) === "[object Array]";
    var hosts = [window.location.host].concat(hostsKnown ? context.assetHosts : []);
    var page = urlWithoutQuery(window.location.href);
    var anyOurs = false;
    var anyUnknown = false;
    var allInline = located.length > 0;
    for (var f = 0; f < located.length; f++) {
      if (ours(located[f], hosts)) anyOurs = true;
      else if (!hostsKnown && /^https?:/.test(located[f])) anyUnknown = true;
      if (urlWithoutQuery(located[f]) !== page) allInline = false;
    }
    // Stack inteira em extensão ou script de terceiro: nada aqui é corrigível no nosso código.
    if (located.length > 0 && !anyOurs && !anyUnknown) return null;

    if (DYNAMIC_IMPORT.test(value) && !properties.$exception_fingerprint) {
      var handled = first.mechanism && first.mechanism.handled === false ? "unhandled" : "handled";
      properties.$exception_fingerprint = "Vite chunk load failed (" + handled + ")";
      if (!properties.$issue_name) properties.$issue_name = "Falha ao carregar chunk do Vite";
    }

    // Sem frame, o PostHog agrupa só pelo tipo e junta 401, 403 e 422 numa issue. Em script
    // inline o arquivo é a URL da página, com o slug da conta, e o mesmo defeito vira uma
    // issue por pousada.
    if (!properties.$exception_fingerprint && (located.length === 0 || allInline)) {
      properties.$exception_fingerprint = type + ": " + normalize(value) + (allInline ? " (inline)" : "");
    }
    return event;
  };
})(window);
